import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { SharedModule } from "src/app/shared/shared.module";
import { JanelasAtualizacaoInformacoesPesquisaComponent } from "./pesquisa/janelas-atualizacao-informacoes-pesquisa";
import { JanelasAtualizacaoInformacoesCadastroComponent } from "./cadastro/janelas-atualizacao-informacoes-cadastro";
import { JanelasAtualizacaoInformacoesListagemComponent } from "./pesquisa/listagem/janelas-atualizacao-informacoes-listagem";
import { JanelasAtualizacaoInformacoesRoutingModule } from "./janelas-atualizacao-informacoes-routing.module";

@NgModule({
    declarations:[
        JanelasAtualizacaoInformacoesPesquisaComponent,
        JanelasAtualizacaoInformacoesListagemComponent,
        JanelasAtualizacaoInformacoesCadastroComponent,
    ],
    exports: [
        JanelasAtualizacaoInformacoesPesquisaComponent,
        JanelasAtualizacaoInformacoesListagemComponent,
        JanelasAtualizacaoInformacoesCadastroComponent,
    ],
    imports:[
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        JanelasAtualizacaoInformacoesRoutingModule,
    ],
    providers:[DatePipe]

})
export class JanelasAtualizacaoInformacoesModule{}